import React from "react";

// Lightweight SVG/CSS chart primitives (no external deps).

export function BarChart({ data, color = "#0C6DA8", height = 180 }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div className="flex items-end gap-1.5" style={{ height }}>
      {data.map((d, i) => (
        <div key={i} className="flex-1 flex flex-col items-center justify-end gap-1.5 group">
          <span className="text-[10px] font-heading font-bold text-brand-navy opacity-0 group-hover:opacity-100 transition-opacity">
            {d.value}
          </span>
          <div
            className="w-full rounded-t-md transition-all"
            style={{ height: `${(d.value / max) * (height - 26)}px`, minHeight: d.value > 0 ? 4 : 0, background: color }}
          />
          <span className="text-[9px] text-brand-slate whitespace-nowrap">{d.label}</span>
        </div>
      ))}
    </div>
  );
}

const DONUT_COLORS = ["#0C6DA8", "#12A5E0", "#F5A623", "#22C55E", "#EF4444", "#8B5CF6"];

export function DonutChart({ data, size = 168 }) {
  const total = data.reduce((s, d) => s + d.value, 0) || 1;
  const r = size / 2 - 14;
  const c = 2 * Math.PI * r;
  let offset = 0;
  return (
    <div className="flex items-center gap-5">
      <svg width={size} height={size} className="shrink-0 -rotate-90">
        {data.map((d, i) => {
          const frac = d.value / total;
          const dash = frac * c;
          const seg = (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={DONUT_COLORS[i % DONUT_COLORS.length]}
              strokeWidth={16}
              strokeDasharray={`${dash} ${c - dash}`}
              strokeDashoffset={-offset}
            />
          );
          offset += dash;
          return seg;
        })}
        <text x="50%" y="50%" className="rotate-90" textAnchor="middle" dominantBaseline="middle"
          transform={`rotate(90 ${size / 2} ${size / 2})`} style={{ fontSize: 22, fontWeight: 800, fill: "#0B2239", fontFamily: "Montserrat" }}>
          {total}
        </text>
      </svg>
      <ul className="space-y-2">
        {data.map((d, i) => (
          <li key={i} className="flex items-center gap-2 text-sm">
            <span className="h-3 w-3 rounded-sm" style={{ background: DONUT_COLORS[i % DONUT_COLORS.length] }} />
            <span className="font-heading font-bold text-brand-navy capitalize">{d.label}</span>
            <span className="text-brand-slate">· {d.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function HBar({ data, color = "#12A5E0" }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <ul className="space-y-3">
      {data.map((d, i) => (
        <li key={i}>
          <div className="flex justify-between text-sm mb-1">
            <span className="font-heading font-bold text-brand-navy">{d.label}</span>
            <span className="text-brand-slate">{d.value}</span>
          </div>
          <div className="h-2.5 rounded-full bg-brand-mist overflow-hidden">
            <div className="h-full rounded-full transition-all" style={{ width: `${(d.value / max) * 100}%`, background: color }} />
          </div>
        </li>
      ))}
    </ul>
  );
}
